// 违章安全教育考试
import React, {  Component } from 'react';
import { href } from '../utils/util';
import { Button, Toast } from 'antd-mobile';

import { post } from '../utils/request';

import api from './api';

import './index.less';

// let submitType;
let EXAMPAPERTYPE = {
    '2':'VIOLATION',
    '3':'CLAIM',
};

let EXAMPAPERTYPE_NAME = {
    'VIOLATION':'违章安全教育考试',
    'CLAIM':'出险安全教育考试'
}
class SafetyTrainingExam extends Component {
    constructor(...args) {
        super(...args);
        this.state = {
            urlOps:{
                app_stoken:'',
                shakeCode:'', //0未中奖、1中奖、2有违章、3有出险、4今日次数已用完、5所有次数已用完
                questionBankCode:'', //违章\出险题库code，resultCode=2或3时有该值
                activityCode:'',
            },
            minutes:0, //分
            seconds:0, //秒
            examDetail:{},
        };
    }
    componentDidMount(){

        var obj = '',obj1 = '',ops={};
        if(window.location.hash.indexOf('?') > -1 ){
            obj = window.location.hash.split('?')[1];
            obj1 = obj.split('&');
            for(var i=0;i<obj1.length;i++){
                ops[obj1[i].split('=')[0]] = obj1[i].split('=')[1] === 'undefined' ? '' : obj1[i].split('=')[1];
            }
            
            if(ops.app_stoken === 'null' || ops.app_stoken === '(null)' || ops.app_stoken === 'undefined' || !ops.app_stoken){
                Toast.fail('您还未登录，请登录后再操作',999);
                return;
            }
            this.setState({
                urlOps: ops
            },()=>{
                this.createExamPaper();
            });
        }
    }

    createExamPaper=()=>{
        let { urlOps } = this.state;
        post({
            url: api.createExamPaper + '?app_stoken=' + urlOps.app_stoken + '&activity=365', 
            data: {
                questionBankCode: urlOps.questionBankCode,
                examPaperType: EXAMPAPERTYPE[urlOps.shakeCode],
            }
        }).then((res) => {
            if(res.result == 'success'){

                var maxtime = res.data.examDuration;
                if (maxtime >= 0) {
                    var minutes = Math.floor(maxtime / 60);
                    var seconds = Math.floor(maxtime % 60);
                }

                this.setState({
                    minutes:minutes,
                    seconds:seconds,
                    examDetail:{...res.data}
                });
            }else{
                
                Toast.info(res.msg,1);
            }
        });

    }


    render() {

        const { urlOps, examDetail, minutes, seconds } = this.state;

        return (
            <div className="exam">
                <div className="top">
                    <div className="topBg"></div>
                </div>
                <div className="box">
                    <div className="title">{examDetail.examPaperName}</div>
                    <div className="content">
                        <div className='grid'>
                            <div className='item-left'>考试类型</div>
                            <div className='item-right'>{EXAMPAPERTYPE_NAME[examDetail.examPaperType]}</div>
                        </div>
                        <div className='grid'>
                            <div className='item-left'>考试标准</div>
                            <div className='item-right'>{minutes}分{seconds}秒</div>
                        </div>
                        <div className='grid'>
                            <div className='item-left'>及格标准</div>
                            <div className='item-right'>{examDetail.passScore}分及格(满分{examDetail.totalScore}分)</div>
                        </div>
                        <div className='grid'>
                            <div className='item-left'>出题规则</div>
                            <div className='item-right'>{examDetail.paperRule || '--'}</div>
                        </div>
                        <div className='message'>
                            温馨提示：考试不能修改答案，每答一题会自动显示结果，交卷后批卷会有考试结果展示。
                        </div>
                    </div>
                    <div className='green'>
                        <Button disabled={!examDetail.examPaperName} type="primary" size='large' className='button' onClick={()=>{
                            href(`/safetyTrainingExamList?app_stoken=${urlOps.app_stoken}&actCode=${urlOps.activityCode}&prizeCode=${urlOps.activityUserPrizeCode}&duration=${examDetail.examDuration}&bankCode=${urlOps.questionBankCode}&paperCode=${examDetail.examPaperCode}&score=${examDetail.totalScore}&num=${examDetail.totalNum}&shakeCode=${urlOps.shakeCode}&name=${examDetail.examPaperName}`);
                        }}>开始考试</Button>
                    </div>
    
                </div> 
            </div>
        );
    }
}
export default SafetyTrainingExam;


// WEBPACK FOOTER //
// ./src/safetyTrainingExam/index.js